var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-top navbar-expand-md navbar-dark",attrs:{"id":"navbar-main"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"h2 mb-0 text-white text-uppercase d-none d-lg-inline-block mt-2"},[_vm._v(_vm._s(_vm.dashboardMode))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa6933e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 